import styled from 'styled-components';
import { globalTheme } from '@cld/component-theme';
import  { switchProp } from '@cld/theme-helper';

const CrumbButton = styled.button`
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
  background: transparent;
  border: transparent;
  cursor: ${switchProp('disabled', {
    true: 'default',
    false: 'pointer',
  })};
  color: ${globalTheme.palette.contrastHigh};
  font-size: ${globalTheme.font.size.xs};
  padding: 0 ${globalTheme.spacing.xs};
  min-width: 3rem;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  flex-shrink: 10;

  &.more-crumb {
    flex: 0 0 1.25rem;
    min-width: 0;
    padding: 0 ${globalTheme.spacing.xxs};
    justify-content: center;
  }

  &.back-arrow {
    min-width: 1rem;
    padding-right: 0;
  }
`;

export default CrumbButton;
